<template>
    <div>
        <the-navbar />
        <v-app-bar app color="primary" dark>
            <v-app-bar-nav-icon
                v-on:click.stop="toggleDrawer"
            ></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <template v-if="null != $store.state.auth.user">
                <v-icon>mdi-account</v-icon>
                <span class="mx-1">{{ $store.state.auth.user.name }}</span>
            </template>
            <v-btn v-on:click="logout" icon class="mx-1">
                <v-icon>mdi-power</v-icon>
            </v-btn>
            <the-progress />
        </v-app-bar>
        <v-main>
            <v-container fluid>
                <router-view />
            </v-container>
        </v-main>
    </div>
</template>

<script>
import snackbar from '@/utils/snackbar';
import { mapMutations } from 'vuex';
import Vue from 'vue';
import authApi from '@/api/authApi';
export default {
    components: {
        'the-progress': () => import('@/components/TheProgress.vue'),
        'the-navbar': () => import('@/components/TheNavbar.vue')
    },
    data() {
        return {};
    },
    mounted() {
        this.initFirebaseMessaging();
        this.subscribeToFcm();
    },
    methods: {
        ...mapMutations({
            setDrawer: 'app/SET_DRAWER'
        }),
        async logout() {
            await this.$store.dispatch('auth/logout');
            this.$router.push('/');
            snackbar.show('Logged out');
            this.$log.info('Logged out.');
        },
        toggleDrawer() {
            this.setDrawer(!this.$store.state.app.drawer);
        },
        async initFirebaseMessaging() {
            Vue.$log && Vue.$log.info('init firebase');
            try {
                const token = await this.$messaging.getToken({
                    vapidKey:
                        'BJdxZJ_rSNZL5o_TVCifkqwZ9Aea7kkHPM3brfWkHhe2rw6nnIhiX9An7TOoMfZRHYngJghEN5f_Kh_nKapkJk8'
                });

                if (token) {
                    Vue.$log.info('token available zzz', [token]);
                    authApi
                        .spaFcmUpdate(token)
                        .then(k => {
                            Vue.$log &&
                                Vue.$log.info(
                                    'fcm token updated to tcd server ' + k
                                );
                        })
                        .catch(e => {
                            Vue.$log.error('fcm server upload error ' + e);
                        });
                }
            } catch (e) {
                // Vue.$log && Vue.$log.error('error init firebase messaging');
                // Vue.$log.error(e);
                console.log(e);
            }
        },
        subscribeToFcm() {
            this.$messaging.onMessage(payload => {
                console.log('fcm message ', payload);
                Vue.$toast.info(payload.notification.body);
            });
        }
    }
};
</script>
